import { cn } from '@/lib/cn';

export function LogoMark({ fill = '#0F766E', glyph = '#FFFFFF', className }: { fill?: string; glyph?: string; className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('size-8 shrink-0', className)} aria-hidden>
      <rect width="32" height="32" rx="8" fill={fill} />
      <path d="M8 9h16v3.2h-6.4V23h-3.2V12.2H8z" fill={glyph} />
    </svg>
  );
}
